<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div class="vx-row" v-if="cardData.c_inactive">
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-8">
        <vx-card class="overflow-hidden">
          <div slot="no-body">
            <div
              class="p-2 box-col"
              :class="{
                'flex justify-between flex-row-reverse items-center': true,
              }"
            >
              <div style="background-color: #37e15d" class="icon-container">
                <img src="@/assets/images/icons/active.svg" />
              </div>
              <div class="truncate p-3">
                <span :class="`text-success`">{{
                  $t("dashboard.label.active")
                }}</span>
                <div style="height: 20px"></div>
                <h2 class="mb-1 font-bold">{{ cardData.c_active }}</h2>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
        <vx-card class="overflow-hidden">
          <div slot="no-body">
            <div
              class="p-2 box-col"
              :class="{
                'flex justify-between flex-row-reverse items-center': true,
              }"
            >
              <div style="background-color: #ff7d1f" class="icon-container">
                <img src="@/assets/images/icons/inactive.svg" />
              </div>

              <div class="truncate p-3">
                <span :class="`text-danger`">{{
                  $t("dashboard.label.inactive")
                }}</span>
                <div style="height: 20px"></div>
                <h2 class="mb-1 font-bold">{{ cardData.c_inactive }}</h2>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
        <vx-card class="overflow-hidden">
          <div slot="no-body">
            <div
              class="p-2 box-col"
              :class="{
                'flex justify-between flex-row-reverse items-center': true,
              }"
            >
              <div style="background-color: #ffcb14" class="icon-container">
                <img src="@/assets/images/icons/allocated.svg" />
              </div>

              <div class="truncate p-3">
                <span :class="`text-warning`">{{
                  $t("dashboard.label.allocated")
                }}</span>
                <div style="height: 20px"></div>
                <h2 class="mb-1 font-bold">{{ cardData.c_allocated }}</h2>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
        <vx-card class="overflow-hidden">
          <div slot="no-body">
            <div
              class="p-2 box-col"
              :class="{
                'flex justify-between flex-row-reverse items-center': true,
              }"
            >
              <div style="background-color: #24c9e7" class="icon-container">
                <img src="@/assets/images/icons/instock.svg" />
              </div>
              <div class="truncate p-3">
                <span style="color: #24c9e7">{{
                  $t("dashboard.label.in_stock")
                }}</span>
                <div style="height: 20px"></div>
                <h2 class="mb-1 font-bold">{{ cardData.c_instock }}</h2>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <div class="vx-row mb-base">
      <div class="sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/4 padding-2">
        <vx-card>
          <div class="">
            <div class="tab-text">
              <div class="flex flex-wrap">
                <div
                  class="sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 padding-3 font-mid"
                >
                  {{ $t("dashboard.label.client_trends_for_head_office") }}
                </div>
                <div class="sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4">
                  <vs-select
                    autocomplete
                    class="selectExample"
                    :placeholder="$t('dashboard.label.OfficeFilter')"
                    v-model="officeId"
                    @input="clientTrendsByOffice"
                    style="margin-left: -80px"
                  >
                    <vs-select-item
                      v-for="(item, index) in officeItem"
                      :key="index"
                      :value="item.id"
                      :text="item.name"
                    />
                  </vs-select>
                </div>
                <div class="sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4">
                  <vs-select
                    autocomplete
                    class="selectExample mr-4 pr-5"
                    :placeholder="$t('dashboard.label.DateFilter')"
                    v-model="calendar"
                    @input="clientTrendsByOffice"
                    style="margin-left: -50px"
                  >
                    <vs-select-item
                      v-for="(item, index) in dateItem"
                      :key="index"
                      :value="item.value"
                      :text="item.text"
                    />
                  </vs-select>
                </div>
              </div>
              <vue-apex-charts
                type="bar"
                class="w-full"
                height="350"
                :options="trendsChartOptions"
                :series="trendsSeries"
              ></vue-apex-charts>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 padding-2">
        <vx-card style="height: 33.3rem">
          <div class="w-full font-mid center">
            {{ $t("dashboard.label.client_details_for_head_office") }}
          </div>
          <div class="tab-text" style="height: 20rem">
            <vue-apex-charts
              type="donut"
              height="350"
              :options="headOfficeDetailChartOption"
              :series="headOfficeDetailChartSeries"
            ></vue-apex-charts>
          </div>
          <div style="height: 4.7rem"></div>
        </vx-card>
      </div>
      <div
        class="sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 padding-2"
        style="margin-top: 2rem"
      >
        <vx-card style="position: relative; height: 22.5rem">
          <div class="w-full font-mid center">
            {{ $t("dashboard.label.Amount_Collected_for_Current_Month") }}
          </div>
          <div class="tab-text" style="position: absolute; top: 3rem">
            <vue-apex-charts
              type="donut"
              height="320"
              :options="apexPieChart.chartOptions"
              :series="apexPieChart.series"
            ></vue-apex-charts>
          </div>
        </vx-card>
      </div>
      <div
        class="sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 padding-2"
        style="margin-top: 2rem"
      >
        <vx-card style="position: relative; height: 22.5rem">
          <div class="w-full font-mid center">
            {{ $t("dashboard.label.Stock_Item_Details_for_Current_Month") }}
          </div>
          <div class="tab-text" style="position: absolute; top: 3rem">
            <vue-apex-charts
              type="donut"
              height="320"
              :options="apexStockChart.chartOptions"
              :series="stockChartSeries"
            ></vue-apex-charts>
          </div>
        </vx-card>
      </div>
      <div
        class="sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 padding-2"
        style="margin-top: 2rem"
      >
        <vx-card style="position: relative; height: 22.5rem">
          <div class="w-full font-mid center">
            {{ $t("dashboard.label.Ticket_Statistics_for_Head_Office") }}
          </div>
          <div class="tab-text" style="position: absolute; top: 3rem">
            <vue-apex-charts
              type="donut"
              height="320"
              :options="apexPieChart.chartOptions"
              :series="apexPieChart.series"
            ></vue-apex-charts>
          </div>
        </vx-card>
      </div>
      <div
        class="sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 padding-2"
        style="margin-top: 2rem"
      >
        <vx-card style="position: relative; height: 22.5rem">
          <div class="w-full font-mid center">
            {{ $t("dashboard.label.STB_Count") }}
          </div>

          <div class="tab-text" style="position: absolute; top: 3rem">
            <vue-apex-charts
              type="donut"
              height="320"
              :options="stbChart.chartOptions"
              :series="stbChart.series"
            ></vue-apex-charts>
          </div>
        </vx-card>
      </div>
    </div>
    <div class="vx-row" v-if="user.username">
      <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full mb-base">
        <vx-card
          :title="$t('dashboard.label.user_profile')"
          class="profile-card-hight"
          style="height: 426px"
        >
          <div class="vx-row p-8">
            <div
              class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full no-padding"
              style="border-right: 1px dashed #777777"
            >
              <div class="p-5" style="border-bottom: 1px dashed #777777">
                {{ $t("dashboard.label.user_name") }}:
              </div>
              <div class="p-5" style="border-bottom: 1px dashed #777777">
                {{ $t("dashboard.label.entity_name") }}:
              </div>
              <div class="p-5" style="border-bottom: 1px dashed #777777">
                {{ $t("dashboard.label.status") }}:
              </div>
              <div class="p-5">{{ $t("dashboard.label.primary_email") }}:</div>
            </div>
            <div
              class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full no-padding"
            >
              <div
                class="p-5 font-semibold"
                style="border-bottom: 1px dashed #777777"
              >
                {{ capitalizeEveryWord(user.username) }}
              </div>
              <div
                class="p-5 font-semibold"
                style="border-bottom: 1px dashed #777777"
              >
                {{ getUserDetail.officeName || "-" }}
              </div>
              <div
                class="p-5 font-semibold"
                style="border-bottom: 1px dashed #777777"
              >
                {{ $t("dashboard.label.authenticated") }}
              </div>
              <div class="p-5 font-semibold">
                {{ getUserDetail.email }}
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
        <vx-card
          :title="$t('dashboard.label.recent_frequent_activities')"
          style="height: 426px; overflow-y: none"
          class="pb-2"
          ><div style="height: 320px; overflow-y: scroll">
            <vx-timeline :data="timelineData" class="mb-2 pb-2" />
          </div>
        </vx-card>
      </div>
    </div>
    <div class="centerx">
      <vs-popup
        button-close-hidden
        :active.sync="active"
        title="Date Filter"
        class="no-header mid-popup popup-close"
      >
        <div class="vx-col mb-2 w-full"></div>
        <div class="vx-row mb-8">
          <div class="vx-col md:w-1/2">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("dashboard.label.StartDate") }}<span class="required"> *</span></small
              >
              <datepicker
                name="start-date"
                :placeholder="$t('dashboard.label.StartDate')"
                v-model="endDate"
                :disabled="dateDisabled"
              ></datepicker>
            </div>
          </div>
          <div class="vx-col md:w-1/2">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("dashboard.label.EndDate") }}<span class="required"> *</span></small
              >
              <datepicker
                name="end-date"
                :placeholder="$t('dashboard.label.EndDate')"
                v-model="startDate"
                :disabled="dateDisabled"
              ></datepicker>
            </div>
          </div>
        </div>
        <div class="center">
          <span class="ml-1 mr-8">
            <vs-button type="border" @click="cancelCustomDate">{{
              $t("dashboard.label.Cancel")
            }}</vs-button>
          </span>
          <span class="mr-8">
            <vs-button @click="customsDate">{{ $t("dashboard.label.Set") }}</vs-button>
          </span>
        </div>
        <div class="p-6"></div>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import { AtomSpinner } from "epic-spinners";
import VueApexCharts from "vue-apexcharts";
import _ from "lodash";
import apexChatData from "../../utils/apexChartData";
import VxTimeline from "@/components/timeline/VxTimeline";
import { routeHistoryData } from "@/router";
import { mapState } from "vuex";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
export default {
  data() {
    return {
      loading: false,
      apexChatData: apexChatData,
      apexPieChart: apexChatData.pieChart,
      apexStockChart: apexChatData.stockChart,
      apexClientChart: apexChatData.clientDetailsChart,
      apexTrendsChart: apexChatData.clientTrendsChart,
      apexStbChart: apexChatData.stbChart,
      headOfficeDetailChartOption: {},
      apexPieChartOptions: apexChatData.pieChart.chartOptions,
      stockChartOptions: {},
      headOfficeDetailChartSeries: [],
      trendsChartOptions: {},
      stockChartSeries: [],
      officeId: 1,
      dateItem: [
        { text: this.$t("dashboard.label.day"), value: "Day" },
        { text: this.$t("dashboard.label.week"), value: "Week" },
        { text: this.$t("dashboard.label.month"), value: "Month" },
      ],
      startDate: moment().subtract(0, "d").format("YYYY-MM-DD"),
      endDate: moment().subtract(7, "d").format("YYYY-MM-DD"),
      dateDisabled: true,
      active: false,
      trendsSeries: [],
      calendar: "Week",
      timelineData: [],
      dashboardCardData: {
        c_active: {
          color: "primary",
          title: "Active",
          icon: "UserCheckIcon",
          value: 0,
        },
        c_inactive: {
          color: "warning",
          title: "InActive",
          icon: "UserXIcon",
          value: 0,
        },
        c_allocated: {
          color: "black",
          title: "Allocated",
          icon: "UserPlusIcon",
          value: 0,
        },
        c_instock: {
          color: "success",
          title: "InStock",
          icon: "DownloadIcon",
          value: 0,
        },
      },
    };
  },
  components: {
    AtomSpinner,
    Datepicker,
    VxTimeline,
    VueApexCharts,
  },
  computed: {
    getUserDetail() {
      return this.$store.getters["auth/userDetail"];
    },
    clientDetailsChart() {
      const clientCounts = this.$store.getters["dashboard/GetClientCounts"];
      const clientDetailsChart = _.cloneDeep(this.apexPieChart);
      clientDetailsChart.series = _.map(clientCounts, "ccounts");
      clientDetailsChart.chartOptions.labels = _.map(clientCounts, "status");
      return clientDetailsChart;
    },
    stbChart() {
      const stbCounts = this.$store.getters["dashboard/GetSTBCounts"];
      const stbChart = _.cloneDeep(this.apexStbChart);
      stbChart.series = _.map(stbCounts, "cnt");
      return stbChart;
    },
    ...mapState({
      cardData: (state) => state.dashboard.carddata,
      clientTrendsData: (state) => state.dashboard.clientTrendsDetail,
      officeItem: (state) => state.dashboard.officeDetails,
      clientHeadDetails: (state) => state.dashboard.clientCounts,
      stockItem: (state) => state.dashboard.stockItemDetail,
      user: (state) => state.auth.user,
    }),
  },
  methods: {
    async clientTrendsByOffice() {
      this.loading = true;
      if (this.calendar == "Custom") {
        this.dateDisabled = false;
        this.active = true;
        return;
      }
      this.trendsChartOptions = {};
      let data = {
        office: this.officeId,
        time: this.calendar,
      };
      let key = this.calendar;
      await this.$store.dispatch("dashboard/setClientTrendsDetails", data);
      this.trendsSeries = [
        {
          name: "New Client Joining",
          data: [],
        },
      ];
      this.trendsChartOptions = this.apexTrendsChart.chartOptions;
      this.trendsChartOptions.xaxis.categories = [];
      for (let tempData of this.clientTrendsData) {
        this.trendsSeries[0].data.push(tempData.count);
        if (this.calendar === "Month")
          this.trendsChartOptions.xaxis.categories.push(tempData.Months);
        if (this.calendar === "Week")
          this.trendsChartOptions.xaxis.categories.push(tempData.Weeks);
        if (this.calendar === "Day")
          this.trendsChartOptions.xaxis.categories.push(
            tempData.days[1] + "/" + tempData.days[2]
          );
      }
      this.loading = false;
      this.getStockItemData();
    },
    cancelCustomDate() {
      this.active = false;
      this.calendar = "";
    },
    customsDate() {
      this.startDate = moment(this.startDate).format("YYYY-MM-DD");
      this.endDate = moment(this.endDate).format("YYYY-MM-DD");
      this.getStockItemData();
      this.active = false;
      this.calendar = "";
    },
    async getDashboardData() {
      this.loading = true;
  
      await this.$store.dispatch("dashboard/setDashBoardData");
      await this.$store.dispatch("dashboard/setOfficeDetails");
      this.loading = false;
      this.clientTrendsByOffice();
    },
    async getStockItemData() {
      this.loading = true;
      await this.$store.dispatch(
        "dashboard/setStockItemDetails",
        this.officeId
      );
      let total =
        this.stockItem[0].disbursedAmount +
        this.stockItem[0].amountToBeDisburse;
      this.stockChartSeries = [
        this.stockItem[0].disbursedAmount,
        this.stockItem[0].amountToBeDisburse,
        total,
      ];
      this.loading = false;
    },
    async getChartClientDetails() {
      this.loading = true;
      await this.$store.dispatch("dashboard/setClientCounts");
      this.headOfficeDetailChartOption = this.apexClientChart.chartOptions;
      this.headOfficeDetailChartOption.labels = [];
      this.headOfficeDetailChartSeries = [];
      let total = 0;
      for (let tempData of this.clientHeadDetails) {
        this.headOfficeDetailChartOption.labels.push(tempData.status);
        this.headOfficeDetailChartSeries.push(tempData.ccounts);
        total = total + tempData.ccounts;
      }
      this.headOfficeDetailChartOption.labels.push("totalClients");
      this.headOfficeDetailChartSeries.push(total);
      this.loading = false;
    },
    async getSTBCounts() {
      this.loading = true;
      this.$store.dispatch("dashboard/setSTBCounts");
      this.loading = false;
    },
    capitalizeEveryWord(str) {
      return str
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    },
  },
  mounted() {
    
    this.getDashboardData();
    this.getChartClientDetails();
    this.getSTBCounts();
    this.timelineData = routeHistoryData;
  },
};
</script>

<style lang="scss">
.something tr td {
  border: 1pt green dotted;
}
.something tr {
  border: none;
}
.chat-card-log {
  height: 400px;

  .chat-sent-msg {
    background-color: #f2f4f7 !important;
  }
}
.cursor {
  cursor: pointer;
}
.padding-2 {
  padding: 0 1.2rem;
}
.padding-3 {
  padding: 0.8rem 1.2rem;
}
.font-mid {
  font-size: 1.05rem;
  font-weight: 530;
}
.center {
  text-align: center;
}
.no-padding {
  padding: 0px !important;
}
.profile-card-hight .vx-card__title {
  padding-left: 20px;
  padding-top: 5px;
}
.ellipse-back {
  position: absolute;
  width: 153px;
  height: 153px;
  left: 65px;
  top: 49px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.08);
}
.box-col {
  position: relative;
  background: #fff;
  height: 100px;
  z-index: 0;
}
.box-col::before {
  position: absolute;
  width: 120px;
  content: "";
  height: 100px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 50px;
  left: 0;
  background: rgb(251, 251, 251);
}
.truncate {
  z-index: 2;
}
.icon-container {
  border-radius: 50%;
  width: 50px;
  height: 50px;
  padding: 13px 12px;
  margin: 15px;
}
</style>
